'use es6';

export default {
  PAID_CAMPAIGNS: '/',
  DASHBOARD: 'dashboard',
  ADVANCED: 'advanced-settings',
  AUDIENCES: 'audiences',
  LEADADS: 'lead-ads',
  EVENTS: 'events'
};